export default __webpack_public_path__ + "static/media/aron-kodesh-mission.fcc269c6.png";